import { useMutation } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import {
  calendarConnectionsService,
  type CalendarProviderSlug,
} from '../api/calendar-connections.service';

/**
 * Starts the OAuth flow for a calendar provider.
 *
 * Fetches the provider authorization URL (authenticated JSON call — the backend
 * does NOT issue an HTTP redirect) and navigates the browser to it. The user
 * returns to `/{activeOrganizationId}/settings?calendarConnection=<status>`.
 */
export function useStartCalendarConnection() {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: async (provider: CalendarProviderSlug) => {
      const returnPath = `/${activeOrganizationId ?? ''}/settings`;
      const authorizationUrl = await calendarConnectionsService.getAuthorizationUrl(
        provider,
        returnPath,
      );
      window.location.href = authorizationUrl;
    },
  });
}
